import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";

/**
 * ReusableModal
 *
 * Props:
 *  - isOpen      {boolean}   controls visibility
 *  - toggle      {function}  called when backdrop/X is clicked
 *  - title       {string|node} optional header text; omit to hide the header
 *  - size        {string}    'sm' | 'md' | 'lg' | 'xl'  (default 'md')
 *  - centered    {boolean}   vertically center the modal
 *  - scrollable  {boolean}   make the body scrollable
 *  - footer      {node}      custom footer content; pass null to hide footer
 *                            if omitted a default "Close" button is rendered
 *  - onClose     {function}  called by the default Close button (falls back to toggle)
 *  - children    {node}      modal body content
 */
const ReusableModal = ({
  isOpen,
  toggle,
  title,
  size = "md",
  centered = false,
  scrollable = false,
  footer,
  onClose,
  children,
}) => {
  const handleClose = onClose || toggle;

  const renderFooter = () => {
    // footer === null  → no footer at all
    if (footer === null) return null;

    // footer supplied  → render it
    if (footer !== undefined) {
      return <ModalFooter>{footer}</ModalFooter>;
    }

    // default fallback → single Close button
    return (
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          Close
        </Button>
      </ModalFooter>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size={size}
      centered={centered}
      scrollable={scrollable}
    >
      {title !== undefined && (
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
      )}
      <ModalBody>{children}</ModalBody>
      {renderFooter()}
    </Modal>
  );
};

export default ReusableModal;
